
export function tryGetForecastIcon(iconUrl: string): string | null {
	let urlParts = iconUrl.split('/');
	let lastPart = urlParts[urlParts.length - 1];
	
	let [filename, extension] = lastPart.split('.');
	
	if ("" === filename) {
		return
	}
	
	return iconUrl;
}